<template>
  <v-autocomplete
      v-model="textValue"
      v-bind="$props"
      :disabled="disabled"
      :label="label ? $t(label) : label"
      :placeholder="placeholder ? $t(placeholder) : placeholder"
      :no-data-text="noDataText ? $t(noDataText) : noDataText"
  />
</template>

<script>
export default {
  name: 'SelectInput',
  props: {
    modelValue: {},
    variant: {
      default: 'solo',
    },
    hideDetails: {
      default: 'auto',
    },
    flat: {
      default: true,
    },
    rounded: {
      default: 9,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    label: String,
    placeholder: String,
    noDataText: String
  },
  data() {
    return {
    };
  },
  emits: ['update:modelValue'],
  computed: {
    textValue: {
      get() {
        return this.modelValue
      },
      set(value) {
        this.$emit('update:modelValue', value)
      }
    },
  },
};
</script>
<style scoped>
:deep(.v-field) {
  border-radius: 9px;
  box-shadow: none;
  filter: brightness(100%) !important;
  transition: background-color 0.5s ease;
}

:deep(.v-field__outline) {
  border: 1px solid rgb(var(--border-color));
  border-radius: 8px;
  color: rgb(var(--boulder-color));
}

:deep(.v-field:hover) {
  border-color: var(--grey-1);
}

:deep(.v-field:focus-within) {
  border-color: rgb(var(--grey-5));
}

.disabled >>> .v-field {
  background-color: rgb(var(--disabled-grey));
  border-radius: 8px;
  transition: background-color 0.5s ease;
}

:deep(.v-field__input) {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  color: rgb(var(--input-text-color));
}

:deep(.v-field__outline) {
  color: rgb(var(--boulder-color));
}

:deep(.v-field--error:not(.v-field--disabled) .v-field__outline) {
  border: 1px solid rgb(var(--error-color));
}

:deep(.v-input__details) {
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 19px;
  padding-inline: 0;
}

:deep(.v-field-label--floating) {
  opacity: 1;
}

:deep(.v-field--variant-solo) {
  color: rgb(var(--gunsmoke-color));
}

:deep(.v-field--variant-solo.v-field--dirty) {
  color: rgb(var(--input-text-color));
}
</style>